<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>

        <div class="col text-right">
          <base-button type="primary" size="sm" v-show="users.length > 15"
            >See all</base-button
          >
          <router-link
            to="/add/user"
            class="nav-link"
            target="/add/user"
            href="/add/user"
          >
            <template v-if="isAdmin">
              <base-button type="success" size="sm">Add User</base-button>
            </template>
          </router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush cursor_pointer"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="users"
      >
        <template slot="columns">
          <th class="text-center">No.</th>
          <th class="text-center">Name</th>
          <th class="text-center">Email</th>
          <th class="text-center">Role</th>
          <th class="text-center">Created At</th>
          <th class="text-center" v-if="isAdmin">Action</th>
          <!-- <th>Actions</th> -->
          <!-- <th>Completion</th> -->
          <!-- <th></th> -->
        </template>

        <template slot-scope="{ row }" class="cursor_pointer">
          <th class="text-center">{{ countIndex(row) }}</th>
          <th class="text-center name">{{ row.firstName + " " + row.lastName }}</th>
          <td class="text-center status">{{ row.email }}</td>
          <td class="text-center mb-0 text-sm text-capitalize">
            {{ row.types | setUserRole }}
          </td>
          <td class="text-center">
            {{ row.createdAt | moment("DD MMM YYYY h:m A") }}
          </td>
          <!-- <td>
            <div class="avatar-group">
              <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Ryan Tompson">
                <img alt="Image placeholder" src="img/theme/team-1-800x800.jpg">
              </a>
              <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Romina Hadid">
                <img alt="Image placeholder" src="img/theme/team-2-800x800.jpg">
              </a>
              <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Alexander Smith">
                <img alt="Image placeholder" src="img/theme/team-3-800x800.jpg">
              </a>
              <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip" data-original-title="Jessica Doe">
                <img alt="Image placeholder" src="img/theme/team-4-800x800.jpg">
              </a>
            </div>
          </td> -->
          <!-- <td>
            <div class="d-flex align-items-center">
              <span class="completion mr-2">{{row.completion}}%</span>
              <div>
                <base-progress :type="row.statusType"
                               :show-percentage="false"
                               class="pt-0"
                               :value="row.completion"/>
              </div>
            </div>
          </td> -->
          <td class="text-center" v-if="isAdmin">
            <span @click="editUserClick(row)"><i class="fa fa-edit"></i></span>
            <span @click="deleteUserClick(row)" style="margin-left: 10px"
              ><i class="fa fa-trash"></i
            ></span>
            <!-- <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <a class="dropdown-item" href="#">Something else here</a>
              </template>
            </base-dropdown> -->
          </td>
        </template>
      </base-table>
    </div>

    <div
      v-if="!total"
      class="no_record text-gray d-flex justify-content-center py-4"
      style="font-size: 14px"
    >
      No Record Found
    </div>

    <div
      v-if="total"
      class="card-footer"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <base-pagination
        align="end"
        :total="total"
        :perPage="perPage"
        :pageCount="pageCount"
        :value="page"
        @input="changePage"
      ></base-pagination>
    </div>

    <modal
      :show.sync="updateUserModal"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <card
        type="secondary"
        shadow
        header-classes="bg-white pb-5"
        body-classes="px-lg-5 py-lg-5"
        class="border-0"
      >
        <template>
          <span
            class="close_update_form cursor_pointer"
            @click="updateUserModal = false"
            >&#10006;</span
          >
          <div class="text-center text-muted mb-4">
            <small>Edit User</small>
          </div>
          <form role="form">
            <div class="mb-3 p-0">
              <base-input
                class="input-group-alternative mb-0"
                placeholder="First Name"
                :class="{ 'input-danger': firstNameErr }"
                addon-left-icon="ni ni-circle-08"
                @keyup="firstNameErr = false"
                v-model="userToUpdate.firstName"
              >
              </base-input>
              <span
                v-show="firstNameErr"
                class="text-danger"
                v-text="firstNameMsg"
              ></span>
            </div>

            <div class="mb-3 p-0">
              <base-input
                class="input-group-alternative mb-0"
                placeholder="Last Name"
                :class="{ 'input-danger': lastNameErr }"
                addon-left-icon="ni ni-circle-08"
                @keyup="lastNameErr = false"
                v-model="userToUpdate.lastName"
              >
              </base-input>
              <span
                v-show="lastNameErr"
                class="text-danger"
                v-text="lastNameMsg"
              ></span>
            </div>

            <div class="mb-3 p-0">
              <base-input
                class="input-group-alternative mb-0"
                type="email"
                placeholder="Email"
                :class="{ 'input-danger': emailErr }"
                addon-left-icon="ni ni-email-83"
                @keyup="emailErr = false"
                v-model="userToUpdate.email"
              >
              </base-input>
              <span
                v-show="emailErr"
                class="text-danger"
                v-text="emailMsg"
              ></span>
            </div>

            <div
              class="m-0 p-0"
              v-if="isAdmin && $store.getters.userData._id != userToUpdate._id"
            >
              <select
                class="form-control form-control-alternative"
                aria-describedby="addon-right addon-left"
                v-model="role"
                :value="role"
              >
                <option
                  v-for="(option, index) in roles"
                  :value="option.value"
                  :key="index"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>

            <div class="text-center">
              <base-button
                id="button-add"
                type="primary"
                class="my-4"
                @click="updateUserClick"
                >Update User</base-button
              >
            </div>
          </form>
        </template>
      </card>
    </modal>
  </div>
</template>
<script>
import moment from "moment";

import * as api from "@/apiList";
export default {
  name: "users-table",
  components: {},
  props: {
    type: String,
    users: Array,
    title: String,
    page: Number,
    perPage: Number,
    total: Number,
    seeAll: Boolean,
  },
  data() {
    return {
      isAdmin:
        this.$store.getters.userData && this.$store.getters.userData.isAdmin,
      updateUserModal: false,
      role: null,
      roles: [
        { text: "Maintainer", value: "maintainer" },
        { text: "Admin", value: "admin" },
      ],
      userToUpdate: {},

      firstNameErr: false,
      lastNameErr: false,
      emailErr: false,
      firstNameMsg: "",
      lastNameMsg: "",
      emailMsg: "",
      passwordMsg: "",

      userToUpdateIndex: null,
    };
  },
  methods: {
    editUserClick(user) {
      this.firstNameErr = false;
      this.lastNameErr = false;
      this.emailErr = false;

      this.userToUpdateIndex = this.users.indexOf(user);
      user.types.map((el) => {
        this.role = el.role;
      });

      this.userToUpdate = { ...user };
      this.updateUserModal = true;
    },
    deleteUserClick(user) {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure to delete this user?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            const data = await api.deleteUser(user._id);
            if (!data.response) {
              this.users.splice(this.users.indexOf(user), 1);
            } else {
              let res = data.response.data;
            }
          }
        },
      });
    },
    async updateUserClick() {
      if (this.validateForm()) {
        this.$store.dispatch("toggleLoader", true);
        this.userToUpdate.types[
          this.userToUpdate.types.findIndex((el) => el.role)
        ] = { role: this.role };
        let udpateRes = await api.updateUser(this.userToUpdate);
        if (!udpateRes.response) {
          this.users[this.userToUpdateIndex] = udpateRes.data.data.user;
          this.$toast.success(udpateRes.data.message);
          this.updateUserModal = false;
        } else {
          this.$toast.error(udpateRes.response.data.message);
        }
      }
      this.$store.dispatch("toggleLoader", false);
    },
    validateForm() {
      let hasErr = false;
      let instance = this;
      let userToUpdate_Inst = this.userToUpdate;
      Object.keys(this.userToUpdate).forEach((elem) => {
        if (!userToUpdate_Inst[elem]) {
          instance[elem + "Err"] = true;
          this[elem + "Msg"] = "This field is required.";
          hasErr = true;
        }
      });
      return !hasErr;
    },

    countIndex(item) {
      let index = this.users.indexOf(item) + 1;
      let page = this.page - 1;
      if (page > 0) {
        if (index == 10) {
          page = page + 1;
          index = 0;
          return page.toString() + index.toString();
        } else {
          return page.toString() + index.toString();
        }
      } else {
        return index.toString();
      }
    },
    changePage(value) {
      this.$emit("pageChange", value);
    },
  },
  mounted() {},
  filters: {
    setUserRole(val) {
      if (val[0]) {
        return val[0].role || "Maintainer";
      } else {
        return 'Maintainer';
      }
    },
  },
  computed: {
    pageCount() {
      let pageCount = this.total / this.perPage;
      if (pageCount > 0) {
        return Math.ceil(pageCount);
      } else {
        return 0;
      }
    },
  },
};
</script>
<style scoped>
.cursor_pointer {
  cursor: pointer;
}
.close_update_form {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 12px;
}
span.text-danger {
  font-size: 12px !important;
}
.input-danger {
  border: 1px solid red !important;
}
</style>
